import React from "react";

import { Button, SyncIcon, ToggleSwitch } from "shared/ui";

import { useIikoIntegrationContext } from "features/IikoIntegration/context";

import { Action, Card, Description, Divider, Row, Text, Title } from "./styles";

/*
* Четвёртый шаг мастера. До появления терминала карточка приглушена: синхронизировать
* номенклатуру, которую некуда отправлять, смысла нет.
*
* Тумблер цен живёт здесь же, но от терминала не зависит: он про то, трогать ли цены
* позиций ночью, а не про саму загрузку каталога.
* */
export const SyncStep = () => {
    const state = useIikoIntegrationContext();

    const available = state.terminals.length > 0;
    const syncing = state.saving.sync;

    return (
        <Card>
            <Row>
                <Text>
                    <Title>Синхронизация номенклатуры</Title>
                    <Description>
                        {available ? state.lastSyncLabel : "Станет доступна после добавления терминала"}
                    </Description>
                </Text>

                <Action>
                    <Button
                        variant="contained"
                        disabled={!available || syncing}
                        onClick={state.runSync}
                    >
                        <SyncIcon />
                        {syncing ? "Загрузка…" : "Синхронизировать"}
                    </Button>
                </Action>
            </Row>

            <Divider />

            <ToggleSwitch
                checked={state.isPriceSyncEnabled}
                onChange={state.togglePriceSync}
                disabled={state.saving.priceSync}
                label="Обновлять цены из iiko автоматически"
                hint="Выключите, если цены ведутся в Restify: ночная синхронизация не будет их перезаписывать"
            />
        </Card>
    );
};
